var React = require('react');

function LegalInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.6204 35.6779L29.6363 39.9001H19.3824L24.5093 33.7176C24.5093 33.7176 24.5093 18.7138 24.5093 9.1001M24.5093 9.1001C23.3982 13.0585 20.3683 15.8296 12.4065 16.4328L8.36517 27.2369C8.05138 30.8594 14.7358 34.646 17.865 27.2369H10.7778L13.9145 18.8454L16.9303 25.0841H32.6146L34.9182 18.9433L37.9945 26.8936H31.6383C31.6383 29.9694 37.072 34.4556 40.9788 28.3851L36.2711 16.3381C32.3505 15.6847 24.5093 13.3222 24.5093 9.1001Z","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

LegalInline.defaultProps = {"width":"49","height":"49","viewBox":"0 0 49 49","fill":"none"};

module.exports = LegalInline;

LegalInline.default = LegalInline;
